import LangEnum from '../../../../../lang/LangEnum';
import {
  CatalogViewGroupBy,
  NotGroupedWarning,
  ResolveNotGroupedWarningParams,
} from './catalogView.types';

export const resolveNotGroupedWarning = ({
  catalogConfig,
  isPending,
  isManualGroupingCriterion,
}: ResolveNotGroupedWarningParams): NotGroupedWarning | null => {
  if (isManualGroupingCriterion || isPending || !catalogConfig) {
    return null;
  }

  const isTargetMissing =
    catalogConfig.groupBy === CatalogViewGroupBy.CLASSIFICATION_TYPE &&
    !catalogConfig.groupTargetId;

  if (isTargetMissing) {
    return LangEnum.CATALOGS_VIEW_NOT_GROUPED_MISSING_TARGET_WARNING;
  }

  return null;
};
